// CustomModal.js
import React from "react";
import "./modal.css";

const CustomModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {children}
        <button onClick={onClose}>Continue</button>
      </div>
    </div>
  );
};

export default CustomModal;
